<template>
	<!-- class="analysis-table" -->
	<el-table :data="analysis_table" :default-sort="{prop: propAttr, order: order}" @sort-change="handleTableSort"
		style="width:100%">
		<!-- 日期 -->
		<el-table-column :label="$t('message.csales.table1')" prop="createtime" align="center" min-width="180px"
			sortable="custom" v-if="checkList.includes('time')">
		</el-table-column>
		<!-- 分公司/分行 -->
		<el-table-column :label="$t('message.csales.table2')" prop="branchname" align="center" min-width="150px"
			sortable="custom" show-overflow-tooltip v-if="checkList.includes('branch')">
		</el-table-column>
		<!-- 部门 -->
		<el-table-column :label="$t('message.csales.table3')" prop="departmentname" align="center" sortable="custom"
			show-overflow-tooltip v-if="checkList.includes('department')">
		</el-table-column>
		<!-- 下单员 -->
		<el-table-column :label="$t('message.csales.table4')" prop="user_id" align="center" min-width="150px"
			sortable="custom" v-if="checkList.includes('member')">
		</el-table-column>
		<!-- 订单号 -->
		<el-table-column :label="$t('message.csales.table5')" prop="order_sn" align="center" min-width="150px"
			sortable="custom" v-if="checkList.includes('order')">
		</el-table-column>
		<!-- 商品 -->
		<el-table-column :label="$t('message.csales.table6')" prop="goods_name" align="center" min-width="150px"
			sortable="custom" show-overflow-tooltip v-if="checkList.includes('goods')">
		</el-table-column>
		<!-- 品牌 -->
		<el-table-column :label="$t('message.csales.table7')" prop="brand_name" align="center" sortable="custom"
			v-if="checkList.includes('brand')">
		</el-table-column>
		<!-- 商品编号 -->
		<el-table-column :label="$t('message.csales.table8')" prop="goods_sn" align="center" min-width="150px"
			sortable="custom" v-if="checkList.includes('sn')">
		</el-table-column>
		<!-- 商品数量 -->
		<el-table-column :label="$t('message.csales.table9')" prop="goods_number" align="center" sortable="custom"
			v-if="checkList.includes('num')">
		</el-table-column>
		<!-- 商品单价 -->
		<el-table-column :label="$t('message.csales.table10')" prop="unit_price" align="center" sortable="custom"
			v-if="checkList.includes('unit_price')">
		</el-table-column>
		<!-- 平均单价 -->
		<el-table-column :label="$t('message.csales.table11')" prop="average_price" align="center" sortable="custom"
			v-if="checkList.includes('average_price')">
		</el-table-column>
		<!-- 地区 -->
		<el-table-column :label="$t('message.csales.table12')" prop="area" align="center" sortable="custom"
			v-if="checkList.includes('area')">
		</el-table-column>
		<!-- 商品描述 -->
		<el-table-column :label="$t('message.csales.table13')" prop="goods_desc" align="center" min-width="1000px"
			sortable="custom" show-overflow-tooltip v-if="checkList.includes('describe')">
			<template v-slot="{row}">
				<!-- class="analysis-table-describe" -->
				<div v-html="row.goods_desc">
				</div>
			</template>
		</el-table-column>
		<!-- 行业平均单价 -->
		<el-table-column :label="$t('message.csales.table14')" prop="average_unit_price" align="center"
			:render-header="labelHead" sortable="custom" v-if="checkList.includes('industry_price')">
		</el-table-column>
		<!-- 行业平均数量 -->
		<el-table-column :label="$t('message.csales.table15')" prop="average_goods_number" align="center"
			:render-header="labelHead" sortable="custom" v-if="checkList.includes('industry_number')">
		</el-table-column>
		<!-- 澳门平均单价 -->
		<el-table-column :label="$t('message.csales.table16')" prop="Macao_price" align="center"
			:render-header="labelHead" sortable="custom" v-if="checkList.includes('Macao_price')">
		</el-table-column>
		<!-- 澳门平均数量 -->
		<el-table-column :label="$t('message.csales.table17')" prop="Macao_number" align="center"
			:render-header="labelHead" sortable="custom" v-if="checkList.includes('Macao_number')">
		</el-table-column>
	</el-table>
</template>

<script>
	import {
		mapState
	} from "vuex";
	import {
		tableSortHandle
	} from "@/utils/publicMethod.js";

	export default {
		mixins: [tableSortHandle],
		props: {
			checkList: Array
		},
		computed: mapState({
			analysis_table: state => state.user.analysis.analysis_table
		}),
		methods: {
			labelHead(h, {
				column,
				index
			}) { // 表头样式
				let l = column.label.length
				let f = 21 //每个字大小
				column.minWidth = f * l //字大小乘个数即长度
				return h('div', {
					style: {
						width: '100%',
						"vertical-align": "middle"
					}
				}, [column.label])
			}
		}
	}
</script>

<style scoped>
	/deep/ .el-table__body-wrapper::-webkit-scrollbar {
	width: 6px; 
	height: 10px; 
	}
	.analysis-table-describe {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
</style>
